import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private messageService: MessageService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = '';
                if (error.error instanceof ErrorEvent) {
                    // client-side error
                    errorMessage = error.error.message;
                } else {
                    // server-side error
                    errorMessage = error.error && error.error.message ? error.error.message : error.message;
                }
                
                // Show a toast for the error
                this.messageService.add({severity:'error', summary: 'Error', detail: errorMessage, life: 3000});
                
                return throwError(() => error);
            })
        );
    }
}
